import styled from "styled-components";

export const FotoAg = styled.section`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 20px 0;

  @media (max-width: 960px) {
    flex-direction: column;
  }
`;
